import {
  socialIcon,
  socialLinks,
  socialName,
  type SocialLinkish,
} from '~/components/ui/SocialIcon';

/**
 * A row of social icon links.
 *
 * One component so the footer, Minister Chee's page and contact all stay
 * identical, and so the "hide rows with no URL" rule lives in exactly one
 * place — the CMS carries a pre-seeded row per platform, and an unfilled row
 * must never become an icon that links nowhere.
 */
/*
 * There is no `tone` prop any more. It existed to invert these icons for the
 * dark footer; every surface that carries them is now the glass bed, so a
 * second style would only be a way for the two to drift apart.
 */
export function SocialRow({
  links,
  size = 'default',
  className = '',
}: {
  links: (SocialLinkish[] | undefined | null)[];
  size?: 'default' | 'small';
  className?: string;
}) {
  const usable = socialLinks(...links);
  if (usable.length === 0) return null;

  const dimensions = size === 'small' ? 'h-9 w-9' : 'h-10 w-10';
  const glyph = size === 'small' ? 16 : 18;

  const style = 'border-sapphire-15 text-sapphire-70 hover:border-sapphire-45 hover:text-sapphire';

  return (
    <ul className={`flex flex-wrap items-center gap-3 ${className}`}>
      {usable.map((link, index) => {
        const Icon = socialIcon(link);
        const name = socialName(link);
        return (
          <li key={`${name}-${index}`}>
            <a
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${name} (opens in a new tab)`}
              title={name}
              className={`flex ${dimensions} items-center justify-center rounded-pill border transition-colors duration-fast ${style}`}
            >
              <Icon size={glyph} />
            </a>
          </li>
        );
      })}
    </ul>
  );
}
